import React, { useState } from "react";
// import Spinner from 'react-bootstrap/Spinner';
import { Space, Spin } from "antd";

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-wrap">
        <Space size="middle">
          <Spin size="large" />
        </Space>
        {/* <div className="loader">
          <Spinner animation="border" role="status">
          </Spinner>
        </div> */}
        {/* <div className="spinner d-flex justify-content-center align-items-center h-100">
          <div className="loader" />
        </div> */}
      </div>
    </div>
  );
};

export default Preloader;
